// Puts exactly `text` on the clipboard. Falls back to a hidden textarea for
// browsers (or non-secure origins) without the async Clipboard API.
export const copyToClipboard = async (text) => {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
      return true
    }
  } catch {
    // fall through to the legacy path
  }

  try {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.setAttribute('readonly', '')
    textarea.className = 'fixed opacity-0'
    document.body.appendChild(textarea)
    textarea.select()
    const copied = document.execCommand('copy')
    document.body.removeChild(textarea)
    return copied
  } catch {
    return false
  }
}

// Copies a Quest's house share link (only the URL, credited to no one) for
// Intercom and OneSignal deep links. Resolves to an ActionToast payload.
export const copyShareLink = async (url) => {
  if (!url) return { type: 'error', title: 'No link available for this Quest' }
  return (await copyToClipboard(url))
    ? { type: 'success', title: 'Link copied', text: url }
    : { type: 'error', title: 'Copy failed', text: url }
}
